define('shared/initializer/form/newHouseAdapters/mixins/NoCardPayable',[
    'shared/lib/RSVP',
    'shared/remote/payment/noCard/pay',
    'shared/page/market',
    'shared/page/partner',
    'shared/page/eTag',
    'shared/util/state',
    'shared/util/state/adapters/order',
    'shared/initializer/form/constants',
    'shared/util/checkout/PaymentMethodManager'
], 
function(
    RSVP,
    payNoCard,
    getMarket,
    getPartner,
    getETag,
    state,
    orderAdapter,
    constants,
    PaymentMethodManager
){

    function Ctor() {}

    function doActualSubmit() {
        var offers;

        return RSVP.resolve()
            .then(function(){
                return state.adapters.add(orderAdapter);
            })
            .then(function(){
                return state.retrieve(constants.State.OrderOfferId);
            })
            .then(function(value){
                offers = value;
                if (!offers || offers.length <= 0) {
                    return RSVP.reject('No offer id specified');
                }
            })
            .then(function(){
                return RSVP.all([
                    getMarket(), 
                    getPartner(), 
                    getETag()
                ]);
            })
            .then(function(values){
                var market = values[0];
                var partner = values[1];
                var etag = values[2];

                return payNoCard({
                    market: market,
                    partner: partner,
                    etag: etag,
                    offers: offers
                });
            });
    }

    Ctor.prototype.doSubmit = function(data) {
        var me = this;

        return PaymentMethodManager.instance.get()
            .then(function(paymentMethod) {
                if (paymentMethod === PaymentMethodManager.METHOD_TYPE_NO_CARD) {
                    return doActualSubmit.call(me);
                }
                else {
                    return data;
                }
            });
    };

    return Ctor;
});
